import React, { useState, useEffect, useRef } from 'react';
import {
  ActionButtonWrapper,
  DescTitle,
  FilterSearch,
  FilterSearchWrap,
  InitialDownloadContent,
  LeftContentWrap,
  MainContent,
  MainTitleWrap,
  RadioOption,
  TextItem,
  TopContent
} from './StepThreeStyle';
import { useAppStore } from 'stores/appStore';
import { Title, TitleDescription } from 'components/atoms';
import FormControl from '@mui/material/FormControl';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RefreshIcon from '@mui/icons-material/Refresh';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import ErrorOutlineRounded from '@mui/icons-material/ErrorOutlineRounded';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';

import {
  getInvalidToken,
  getNewDataNonMaster,
  getProductListing,
  getStoreLocation,
  getVariationsList,
  postProductList,
  postRetryDownload,
  redownloadAllEmptySkus,
  saveNewSKUs,
  setWizardSetup,
  uploadNewSKUs
} from 'api/masterStore';
import { LiteGrid } from 'components/LiteGrid/LiteGrid';
import { Column, RowButton } from 'components/LiteGrid/DataGrid.types';
import { QueryParameters } from 'lib/types';
import { showAlert } from 'components/Alert';
import { Image } from 'components/Image/Image';
import { Button, CircularProgress, Grid, InputAdornment, LinearProgressProps, TextField, Tooltip } from '@mui/material';
import { DeleteSVG, DownloadSVG, EditSVG, ImportSVG, SaveSVG, SearchSVG, UploadSVG } from 'assets/img';
import { AsyncButton } from 'components/ButtonNew/Button';
import { ModalAction } from 'components/ModalAction/ModalAction';
import { useForm } from 'react-hook-form';
import FilterBar from 'components/FilterBar/FilterBar';
import LightTooltip from 'components/LightTooltip';
import Box from '@mui/material/Box';
import LineProgress from 'components/LineProgress';
import SelectButton, { SelectButtonItemProps } from 'components/SelectButton/SelectButton';
import withModalIntegration from 'views/withModalIntegration';
import { DropdownStoreRoot } from './DropdownStores/Root';
import { ModalImportSKU, ResponseImport } from 'components/ModalImport/ModalImportSKU';
import { CHANNELS } from 'shared/constants';
import DropdownSkuRecommendation from './DropdownSkuRecommendation';
import { getWordingErrorMsg } from '../StepThree/InitialDownload';

interface FormValues {
  q: string;
}

interface OtherFilterProps {
  status?: string | null;
  type?: string | null;
}

const progressLabels = {
  counting: 'Menghitung produk dari toko...',
  downloading: 'Mendownload produk dari toko...',
  finished: 'Selesai mendownload produk dari toko.',
  downloaded: 'Selesai mendownload produk dari toko.',
  uploading: 'Mengunggah SKU ke marketplace...',
  uploaded: 'Selesai mengunggah SKU ke marketplace',
  importing: 'Mengimpor produk ke sistem...',
  imported: 'Selesai mengimpor produk ke sistem',
  importing_failed: 'Gagal mengimpor produk ke sistem',
  load_recommendations: 'Memuat rekomendasi SKU...'
}

const InitialDownload = (props: any) => {
  const query = useRef<QueryParameters>();
  const refresher = useRef<() => void>();
  const setQuery = useRef<(e: QueryParameters) => QueryParameters>();
  const { setCompleteValidation, openModal } = props;
  // const [totalDownloaded, setTotalDownloaded] = useState(0);
  // const [totalProduct, setTotalProduct] = useState(0);
  const [busy, setBusy] = useState(true);
  const [deletingItem, setDeletingItem] = useState([]);
  const [deleteConfirmation, setDeleteConfirmation] = useState(false);
  const [sku, setSku] = useState('all');
  const [statusDownload, setStatusDownload] = useState('all');
  const [detailStore, setDetailStore] = useState<any>({});
  const [isTableOpen, setTableOpen] = useState(false);
  const [downloadState, setDownloadState] = useState('idle');
  // const [downloadPercentage, setDownloadPercentage] = useState(0);
  const [isError, setIsError] = useState(false);
  const [storeDownloadState, setStoreDownloadState] = useState([]);
  const [masterStoreId, setMasterStoreId] = useState<number | null>(null);
  const isMounted = useRef<boolean>(true);
  const [isEditingColumnSKU, setIsEditingColumnSKU] = useState(false);
  const [changedSKUs, setChangedSKUs] = useState(
    new Map<string, { newItemCode: string; itemCode: string; skuRecommendations: Record<string, unknown>[] }>()
  );
  const {
    setDisablePrevButton,
    setValidationComplete,
    setChannelIdOto,
    cantSkip,
    canSkip,
    setActiveStep
  } = useAppStore();
  const currentProgress = useRef<string>('idle');
  const selectedItemIds = useRef<Array<string>>([]);
  const importResult = useRef<Partial<ResponseImport>>({})
  const [progressState, setProgressState] = useState<{
    label: string;
    percentage: number;
    count: string;
    color?: LinearProgressProps['color'];
  }>({
    label: 'Memuat produk dari toko...',
    percentage: 0,
    count: 'Memuat produk...'
  });
  const { register, handleSubmit, setValue, getValues } = useForm<FormValues>({
    defaultValues: {
      q: ''
    }
  });
  const [isShowModalImport, setIsShowModalImport] = useState(false);

  const handleChangeStatusDownload = (event: React.ChangeEvent<HTMLInputElement>) => {
    setStatusDownload((event.target as HTMLInputElement).value);
  };
  const handleChangeSKU = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSku((e.target as HTMLInputElement).value);
  };

  const getStoreDetail = async (storeId) => {
    try {
      const res = await getStoreLocation(storeId);
      setDetailStore(res.data);
    } catch (err) {
      const error = err as Error;
      console.log(error);
      showAlert('error', `${error}`, 5000);
    }
  };

  const handleActionTable = async (data) => {
    try {
      setBusy(true);
      const ids = data.map((row) => row.channel_group_id);
      let payload = {
        channelId: data[0].channel_id,
        storeId: data[0].store_id,
        isMaster: data[0].is_master,
        ids
      };
      const res: any = await postRetryDownload(payload);
      if (res.status === 200) {
        refresher.current();
        showAlert('success', 'Berhasil download ulang');
      }
    } catch (err) {
      const error = err as Error;
      console.log(error);
      setBusy(false);
      showAlert('error', `${error}`, 5000);
    }
  };

  const handleDelete = async (data) => {
    const newData = [];
    for (let idx = 0; idx < data.length; idx++) {
      const o = data[idx] as any;
      let result: any = {
        indx: idx,
        id: o.channel_item_id ? o.channel_item_id : o.channel_group_id,
        label: `${o.item_name}`,
        channelId: o.channel_id,
        storeId: o.store_id,
        isMaster: false,
        busy: null,
        success: null,
        isVariant: true,
        skus: [
          {
            item_code: o.item_code
          }
        ]
      };

      if (o.is_error) {
        const variations = await getVariationsList(o.channel_id, o.store_id, o.channel_group_id);
        result.skus = variations.data.data[0].skus;
        result.isVariant = false;
        result.id = o.channel_group_id;
      }

      newData.push(result);
    }

    setDeletingItem(newData);
    setDeleteConfirmation(true);
  };


  const getOnBoardingSetup = async (): Promise<number> => {
    try {
      const res = await setWizardSetup();
      const setupData = res?.data?.setup;
      const masterSelected = setupData.master_channel_id;
      return masterSelected;
    } catch (err) {
      const error = err as Error;
      console.log(error);
      showAlert('error', `${error}`, 5000);
    }
  };

  const getIntegratedChannels = async () => {
    try {
      const res = await getNewDataNonMaster();
      const excludeMaster = res?.data?.data?.filter((val) => Number(val.store_id) !== masterStoreId && val.channel_id !== 1);
      let newRes = excludeMaster.map((val) => ({
        store_name: val.store_name,
        store_id: val.store_id,
        channel_id: val.channel_id,
        is_downloaded: val.is_downloaded,
        total_downloaded: val.total_downloaded,
        all_product: val.all_product,
        on_download_process: val.on_download_process
      }));
      setStoreDownloadState(newRes);
    } catch (err) {
      const error = err as Error;
      console.log(error);
      showAlert('error', `${error}`, 5000);
    }
  };

  const lazadaEmptySKU = (data) => {
    return (data.channel_id === CHANNELS.LAZADA && data.item_code?.split('-').includes(data.channel_group_id)) || false
  }

  useEffect(() => {
    if (isMounted.current) {
      setDisablePrevButton(true);
      getOnBoardingSetup().then(id => {
        setMasterStoreId(id);
        getIntegratedChannels();
      });
      isMounted.current = false;
    }
  }, []);

  const renderProduct = (
    _cellData: undefined,
    rD: { img_url: string; item_name: string; item_code: string; is_bundle: boolean; item_id: string }
  ) => {
    const name = ((rD && rD.item_name) || '').length > 30 ? `${rD.item_name.slice(0, 30)}...` : rD && rD.item_name;
    return (
      <div className="d-flex align-items-center font-size-table">
        <Image src={rD.img_url} height={35} width={35} className="border 1 border-light-gray rounded-sm mt-1 mb-1" />
        <div className="d-flex flex-column ml-3">
          <LightTooltip title={rD.item_name} arrow>
            <span className="text-nowrap">{name}</span>
          </LightTooltip>
          <span className="font-weight-normal">{rD.item_code}</span>
        </div>
      </div>
    );
  };

  const renderProductMaster = (
    _cellData: undefined,
    rD: { img_url: string; master_item_name: string; master_item_code: string; is_bundle: boolean; item_id: string }
  ) => {
    const name = rD && rD.master_item_name?.length > 30 ? `${rD.master_item_name?.slice(0, 30)}...` : rD?.master_item_name;
    return (
      <>
        {rD.master_item_code !== null ? (
          <div className="d-flex align-items-center font-size-table">
            <Image
              src={rD.img_url}
              height={35}
              width={35}
              className="border 1 border-light-gray rounded-sm mt-1 mb-1"
            />
            <div className="d-flex flex-column ml-3">
              <span className="text-nowrap">{name}</span>
              <span className="font-weight-normal">{rD.master_item_code}</span>
            </div>
          </div>
        ) : (
          '-'
        )}
      </>
    );
  };

  const columns: Column[] = [
    {
      header: 'Produk',
      binding: 'item_name',
      format: 'string',
      allowSorting: true,
      freezeCol: true,
      template: renderProduct
    },
    {
      header: 'Produk Master',
      binding: 'master_item_name',
      format: 'string',
      allowSorting: true,
      freezeCol: false,
      template: renderProductMaster
    },
    ...(([CHANNELS.SHOPEE, CHANNELS.LAZADA, CHANNELS.TIKTOK].includes(detailStore.channel_id)
      ? [
        {
          header: 'Rekomendasi SKU',
          binding: 'sku_recommendations',
          format: 'string',
          template: (row, data) => {
            // find sku_recommendations where selected is true
            const selectedRecommendation = data.sku_recommendations?.find((item) => item?.selected) || null;
            // render DropdownRecommendation component
            return (
              <DropdownSkuRecommendation
                key={data.channel_item_id}
                readonly={!isEditingColumnSKU}
                selected={selectedRecommendation}
                data={data.sku_recommendations || []}
                onSelection={(item) => {
                  const newSKUs = new Map(changedSKUs);
                  newSKUs.set(`${data.channel_item_id}`, {
                    newItemCode: item.item_code,
                    itemCode: data.channel_item_id,
                    skuRecommendations:
                      item.type === 'freeText'
                        ? data.sku_recommendations?.map((rec) => ({
                          ...rec,
                          selected: false
                        })) || []
                        : data.sku_recommendations || []
                  });
                  setChangedSKUs(newSKUs);
                }}
              />
            );
          }
        }
      ]
      : []) as Column[]),
    {
      header: 'Status Download',
      headerClassName: 'text-center text-second text-nowrap',
      width: 180,
      allowSorting: false,
      binding: 'status',
      template: (row, data) => {
        const renderProgress = () => {
          if (data.status === 'failed') {
            return (
              <LightTooltip title={data.error_message} placement="bottom" arrow>
                <ErrorOutlineRounded fontSize="medium" className="text-danger" />
              </LightTooltip>
            );
          } else if (data.status === 'downloaded') {
            return <CheckCircleOutlineIcon fontSize="medium" style={{ color: '#4CAF50' }} />;
          } else {
            return <CircularProgress size={24} />;
            // return <WarningAmberIcon fontSize="medium" style={{ color: 'rgb(255, 152, 0)' }} />;
          }
        };
        return <div className="text-center py-2">{renderProgress()}</div>;
      }
    },
    {
      header: 'Status Upload',
      headerClassName: 'text-center text-second text-nowrap',
      width: 180,
      allowSorting: false,
      binding: 'status_upload',
      template: (_row, data) => {
        const renderProgress = () => {
          if (data.uploading_status === 'uploading' || selectedItemIds.current.includes(data.channel_item_id) && currentProgress.current === 'uploading') {
            return <CircularProgress size={24} />;
          } else if (data.status_upload === 'uploaded') {
            return <CheckCircleOutlineIcon fontSize="medium" style={{ color: '#4CAF50' }} />;
          } else if (data.upload_error_message) {
            return (
              <Tooltip title={data.upload_error_message} placement="bottom" arrow>
                <ErrorOutlineRounded fontSize="medium" className="text-danger" />
              </Tooltip>
            );
          } else {
            return <span>-</span>;
          }
        }
        return <div className="text-center py-2">{renderProgress()}</div>;
      }
    }
    // {
    //   header: 'Tindakan',
    //   binding: 'channel_item_id',
    //   headerClassName: 'text-center text-second text-nowrap',
    //   className: 'font-size-table text-center',
    //   allowSorting: false,
    //   template: (row, data, isChecked) => {
    //     const shouldRefresh = isChecked || data?.status === 'waiting';

    //     return (
    //       <RefreshIcon
    //         color={shouldRefresh ? 'disabled' : 'primary'}
    //         style={shouldRefresh ? {} : { cursor: 'pointer' }}
    //         onClick={() => {
    //           if (!shouldRefresh) {
    //             handleActionTable([data]);
    //           }
    //         }}
    //       />
    //     );
    //   }
    // },
    // {
    //   header: '',
    //   binding: '',
    //   template: (row, data, isChecked) => {
    //     const renderDelete = () => {
    //       if (isChecked) {
    //         return <DeleteSVG className="disabled" />;
    //       } else if (data.status !== 'waiting') {
    //         return <DeleteSVG className="text-danger" onClick={() => handleDelete([data])} />;
    //       } else if (isChecked || data?.status === 'waiting') {
    //         return <DeleteSVG className="disabled" />;
    //       }
    //     };
    //     return (
    //       <div className="text-center py-2" style={{ cursor: 'pointer' }}>
    //         {renderDelete()}
    //       </div>
    //     );
    //   }
    // }
  ];

  const getQuery = (q: QueryParameters) => {
    query.current = q;
  };

  const getSetQuery = (fn) => {
    setQuery.current = fn;
  };

  const validationCheck = async (state) => {
    const currentStore = detailStore.store_id;
    if (state === 'finished') {
      setCompleteValidation('DOWNLOADED', true);
    } else {
      setCompleteValidation('DOWNLOADED', false);
    }

    const getEmptySku = await getProductListing(currentStore, { page: 1, pageSize: 10, type: 1, q: '' });
    const response = getEmptySku.data.data;
    const emptySkusFound = Number(response.count) > 0;
    const currentStoreState = storeDownloadState.find((val) => val.store_id === currentStore)

    if ((!emptySkusFound && state === 'finished') || currentStoreState.is_downloaded) {
      setCompleteValidation('VALID_SKU', true);
      setValidationComplete(true);
    } else {
      setCompleteValidation('VALID_SKU', false);
      setValidationComplete(false);
    }

    const getDuplicateSku = await getProductListing(currentStore, { page: 1, pageSize: 10, type: 3, q: '' });
    const responseDuplicate = getDuplicateSku.data.data;
    const duplicateSkuFound = Number(responseDuplicate.count) === 0;
    if (duplicateSkuFound) {
      setCompleteValidation('DUPLICATE_SKU', true);
    } else {
      setCompleteValidation('DUPLICATE_SKU', false);
    }
  };

  const onCheckInvalidToken = async (storeId) => {
    const res = await getInvalidToken(storeId);
    setIsError(Boolean(res?.data[0]?.invalid_token));
  };

  const getFetcher = async (options: QueryParameters & OtherFilterProps) => {
    const res = await getProductListing(detailStore.store_id, options, 'non_master');
    const responseData = res?.data?.data;
    const downloadIdle = res?.data.state === 'idle';

    const isSearching =
      query.current?.q !== '' ||
      (options?.status !== '' && typeof options?.status !== 'undefined') ||
      (options?.type !== '' && typeof options?.type !== 'undefined');

    const downloadStatus =
      Number(responseData?.count) > 0 && responseData?.percent === 100 && downloadIdle
        ? 'finished'
        : res?.data?.state;
    const uploadStatus =
      responseData?.upload_progress?.percent == 100
        ? 'uploaded'
        : 'uploading';
    const importStatus =
      responseData?.import_progress?.percent == 100
        ? 'imported'
        : 'importing';

    const openTable =
      downloadStatus === 'counting' ||
      downloadStatus === 'downloading' ||
      downloadStatus === 'finished' ||
      isSearching;

    const importRunning = responseData?.import_progress?.percent < 100 && responseData?.import_progress?.importing > 0;
    const uploadRunning = responseData?.upload_progress?.percent < 100 && responseData?.upload_progress?.uploading > 0;

    if (currentProgress.current === 'uploading' || uploadRunning) {
      const totalCount = Number(responseData?.upload_progress?.uploaded) + Number(responseData?.upload_progress?.uploading) + Number(responseData?.upload_progress?.failed);
      const uploadFinished = responseData?.upload_progress?.percent == 100;
      const countDefaultText = `${responseData?.upload_progress?.uploaded} dari ${totalCount} produk`
      const fail = responseData?.upload_progress?.failed > 0 && uploadFinished;

      if (uploadFinished) {
        currentProgress.current = 'uploaded'
        setBusy(false)
      }
      setProgressState({
        label: progressLabels[uploadStatus] || 'Memuat produk dari toko...',
        percentage: responseData?.upload_progress?.percent || 0,
        count: countDefaultText,
        color: fail ? 'error' : undefined
      })
      setDownloadState(uploadStatus);
    } else if (currentProgress.current === 'importing' || importRunning) {
      const totalCount = Number(responseData?.import_progress?.imported) + Number(responseData?.import_progress?.importing) + Number(responseData?.import_progress?.failed);
      const fail = responseData?.import_progress?.percent == 100 && responseData?.import_progress?.failed > 0;
      const importFinished = responseData?.import_progress?.percent == 100;
      const countDefaultText = `${importResult.current?.success || responseData?.import_progress?.imported} dari ${importResult.current?.total_rows || totalCount} produk`

      if (importFinished) {
        currentProgress.current = 'imported'
        setBusy(false)
      }
      setProgressState({
        label: progressLabels[importStatus] || 'Memuat produk dari toko...',
        percentage: responseData?.import_progress?.percent || 0,
        count: countDefaultText,
        color: fail ? 'error' : undefined
      })
      setDownloadState(importStatus);
    } else {
      if (!['imported', 'uploaded'].includes(currentProgress.current)) {
        setProgressState({
          label: progressLabels[downloadStatus] || 'Memuat produk dari toko...',
          percentage: responseData?.percent || 0,
          count: `${Math.floor(Number(responseData?.count) * (responseData?.percent / 100))} dari ${responseData?.count} produk`
        })
        setDownloadState(downloadStatus);
      }
    }

    if (downloadStatus === 'finished' && responseData.recommendation_status == 'progress') {
      setProgressState(state => ({
        ...state,
        label: progressLabels[downloadStatus] || 'Memuat produk dari toko...',
      }))
      setDownloadState(responseData.recommendation_status);
    }

    setTableOpen(openTable);

    await validationCheck(downloadStatus);

    const data = {
      ...res,
      data: res?.data?.data?.products || [],
      totalCount: res?.data?.data?.count || '0'
    };

    if (downloadStatus === 'idle' || downloadStatus === 'finished') {
      onCheckInvalidToken(detailStore.store_id ?? props.data);
      if (downloadStatus === 'finished') setBusy(false)
    }

    return data;
  };

  const fetcher = React.useMemo(() => {
    return (options: QueryParameters) => {
      return getFetcher(options);
    };
  }, [detailStore]);

  function handleRowAction(item: any, binding, index) { }

  const isRowLocked = (row) => {
    if (row.status === 'waiting' && downloadState !== 'finished' || isEditingColumnSKU) {
      return true;
    } else if (downloadState === 'finished' && row.status !== 'downloaded') {
      return false;
    } else {
      return false;
    }
  };

  const uploadSkuMarketplace = async (data) => {
    // except row with status failed or empty item_code
    const valid = data.every((row) => row.status !== 'failed' && row.item_code && !lazadaEmptySKU(row));
    if (!valid) {
      showAlert(
        'warning',
        'Data Produk tidak Valid',
        undefined,
        'Saat ini, proses upload tidak dapat dilanjutkan, Silahkan cek kembali data produk Anda.\n Terdapat beberapa produk dengan sku kosong atau gagal download.',
        'modal'
      );
      return;
    }

    setBusy(true);
    const ids = data.map((row) => row.channel_item_id);
    selectedItemIds.current = ids;
    currentProgress.current = 'uploading';
    setProgressState({
      label: progressLabels.uploading,
      percentage: 0,
      count: `0 dari ${ids.length} produk`
    })
    uploadNewSKUs({
      channelGroupIds: [],
      channelItemIds: ids,
      storeId: detailStore.store_id
    }).then((res: any) => {
      setDownloadState('uploading');
      showAlert('success', res.data.message);
    }).catch((err) => {
      // error handling
      setBusy(false)
    });
  }

  const rowButton: RowButton<any>[] = [
    {
      text: 'Download Ulang',
      icon: <DownloadSVG fill="#163A50" />,
      iconColor: '#4B68EF',
      action: handleActionTable,
      iconHeaderWithText: true,
    },
    {
      text: 'Upload Marketplace',
      icon: <UploadSVG />,
      iconColor: '#4B68EF',
      action: uploadSkuMarketplace,
      iconHeaderWithText: true,
      disabled: (row) => {
        return row.status === 'failed' || !row.item_code;
      }
    }
  ];

  const handleReset = async () => {
    const newQuery: QueryParameters & OtherFilterProps = {
      ...query.current,
      q: '',
      page: 1
    };

    newQuery.status = '';
    newQuery.type = '';

    setValue('q', '');
    setStatusDownload('all');
    setSku('all');

    setQuery.current?.(newQuery);
  };

  const handleSubmitSearch = async (formvalue) => {
    const newQuery: QueryParameters & OtherFilterProps = {
      ...query.current,
      q: formvalue.q,
      page: 1
    };

    newQuery.type = sku === 'all' ? '' : sku;
    newQuery.status = statusDownload === 'all' ? '' : statusDownload;

    setQuery.current(newQuery);
  };

  const handleDownloadAll = async () => {
    try {
      setBusy(true);
      setTableOpen(true);
      const res = await postProductList(detailStore.channel_id, detailStore.store_id, false, false);
      if (res.data.status === 'ok') {
        showAlert('success', `${res.data.message}`, 5000);
        refresher.current();
      }
    } catch (err) {
      const error = err as Error;
      showAlert('error', `${error}`, 5000);
    }
  };

  const handleDownloadEmptySku = async () => {
    try {
      setBusy(true);
      const storeId = detailStore.store_id;
      const res: any = await redownloadAllEmptySkus(storeId, detailStore.channel_id, false);
      if (res.data.status === 'ok') {
        showAlert('success', `${res.data.message}`, 5000);
        refresher.current();
      }
    } catch (err) {
      const error = err as Error;
      console.log(error);
      showAlert('error', `${error}`, 5000);
    }
  };

  const onDeleteClose = async () => {
    setDeleteConfirmation(false);
    refresher.current();
  };

  const handleSelectedStore = async (selectedStore) => {
    await handleReset();
    await getStoreDetail(selectedStore.store_id);
    setBusy(false);
    setTableOpen(true);
    setProgressState({
      label: progressLabels.downloaded,
      percentage: 0,
      count: '0 dari 0 produk',
      color: undefined
    })
  };

  useEffect(() => {
    let interval: NodeJS.Timer;
    if (isTableOpen && (
      downloadState === 'downloading' ||
      downloadState === 'counting' ||
      downloadState === 'uploading' ||
      downloadState === 'importing' ||
      downloadState == 'load_recommendations')
    ) {
      const updateData = async () => {
        await getIntegratedChannels();
        refresher.current();
      };
      updateData();

      interval = setInterval(updateData, 10000);
    } else {
      if (interval) {
        clearInterval(interval);
      }
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [isTableOpen, downloadState, masterStoreId]);

  const handleOtoriation = () => {
    setChannelIdOto(detailStore.channel_id);
    setDisablePrevButton(true);
    cantSkip();
    setActiveStep(2);
  };

  const downloadButtonStatus = busy || downloadState === 'downloading' || downloadState === 'counting';
  const titleText = downloadState === 'downloading' || downloadState === 'counting' ? 'Proses' : 'Selesai';

  const downloadOptions: SelectButtonItemProps[] = [
    {
      label: 'Download Semua Produk',
      desc: 'Download  seluruh data produk yang ada di toko.',
      icon: <DownloadSVG fill="#163A50" />,
      handler: () => {
        handleDownloadAll();
      }
    },
    {
      label: 'Download Produk SKU Kosong',
      desc: 'Download daftar produk yang belum memiliki SKU untuk memudahkan pengecekan dan pembaruan data.',
      icon: <DownloadSVG fill="#163A50" />,
      handler: () => {
        handleDownloadEmptySku();
      }
    }
  ];

  return (
    <div>
      <InitialDownloadContent>
        <TopContent>
          <FilterSearchWrap>
            <p className="mr-4">Download produk dari toko</p>
            <div style={{ width: '300px' }}>
              {/* <FilterBar
                totalDownloaded={totalDownloaded}
                totalProduct={totalProduct}
                stores={storeDownloadState}
                handleSelectedStore={handleSelectedStore}
              /> */}
              <DropdownStoreRoot masterStoreId={masterStoreId} handleSelectedStore={handleSelectedStore} />
            </div>
            {isError && (
              <LightTooltip
                title={
                  <span>
                    Toko ini perlu otorisasi ulang.{' '}
                    <span
                      className="text-link"
                      onClick={() => {
                        openModal(detailStore);
                      }}
                    >
                      Klik disini
                    </span>{' '}
                    untuk melakukan otorisasi ulang toko
                  </span>
                }
                placement="bottom"
                arrow
              >
                <ErrorOutlineRounded fontSize="medium" className="text-danger ml-2" />
              </LightTooltip>
            )}
          </FilterSearchWrap>
          <ActionButtonWrapper>
            <AsyncButton
              onClick={async () => {
                setIsShowModalImport(true);
              }}
              variant="outlined"
              type="button"
              hidden={!isTableOpen}
              color="inherit"
              className="px-4"
              startIcon={<ImportSVG />}
            >
              Import
            </AsyncButton>
            <SelectButton label={'Download'} busy={downloadButtonStatus} options={downloadOptions} />
          </ActionButtonWrapper>
        </TopContent>
        {(downloadState === 'finished' || isTableOpen) && (
          <MainContent>
            <MainTitleWrap>
              <div>
                <Title>
                  {progressState.label}
                  {/* {titleText} Mendownload Produk dari {detailStore?.store_name} */}
                </Title>
                <TitleDescription>{progressState.count}</TitleDescription>
                {/* {busy ? (
                  <TitleDescription>{`${totalProduct} produk`}</TitleDescription>
                ) : (
                  <TitleDescription>{`${totalDownloaded} dari ${totalProduct}`}</TitleDescription>
                )} */}
              </div>
            </MainTitleWrap>
          </MainContent>
        )}
      </InitialDownloadContent>

      {(downloadState === 'finished' || isTableOpen) && (
        <Grid container spacing={2}>
          <Grid item md={12}>
            <Box sx={{ width: '100%' }}>
              <LineProgress color={progressState.color || 'primary'} value={progressState.percentage} />
              {downloadState === 'import_failed' && (
                <Box sx={{ width: '100%' }}>
                  <div className="text-danger" style={{ fontSize: '14px' }}>
                    {importResult.current.errors?.map((err, index) => (
                      <p key={index} className="text-danger mb-1">
                        <span>{`Baris ${err.row}: `}</span>{' '}
                        <span>{`${getWordingErrorMsg(err.error)}`}</span>
                      </p>
                    ))}
                  </div>
                </Box>
              )}
            </Box>
          </Grid>
          <Grid item md={3}>
            <LeftContentWrap>
              <form onSubmit={handleSubmit(handleSubmitSearch)}>
                <FilterSearch>
                  <FilterSearchWrap>
                    <p className="m-0">Filter</p>
                    <AsyncButton
                      color="inherit"
                      type="button"
                      className="text-danger px-0 hover-none"
                      onClick={handleReset}
                      disabled={busy || isEditingColumnSKU}
                    >
                      Reset
                    </AsyncButton>
                  </FilterSearchWrap>
                  <TextField
                    disabled={busy}
                    variant="outlined"
                    size="small"
                    className="bg-white rounded-sm no-notch mb-3"
                    placeholder="Cari Produk, SKU Produk"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchSVG />
                        </InputAdornment>
                      )
                    }}
                    {...register('q')}
                  />
                </FilterSearch>
                <RadioOption>
                  <DescTitle>Status Download</DescTitle>
                  <FormControl>
                    <RadioGroup value={statusDownload} onChange={handleChangeStatusDownload}>
                      <FormControlLabel
                        disabled={busy}
                        value="all"
                        className="mb-1"
                        control={<Radio sx={{ padding: '2px', marginLeft: '10px' }} size="small" />}
                        label={<TextItem>Semua</TextItem>}
                      />
                      <FormControlLabel
                        disabled={busy}
                        value="failed"
                        className="mb-1"
                        control={<Radio sx={{ padding: '2px', marginLeft: '10px' }} size="small" />}
                        label={<TextItem>Gagal Download</TextItem>}
                      />
                    </RadioGroup>
                  </FormControl>
                </RadioOption>
                <RadioOption>
                  <DescTitle>Kelengkapan SKU Produk</DescTitle>
                  <FormControl>
                    <RadioGroup value={sku} onChange={handleChangeSKU}>
                      <FormControlLabel
                        disabled={busy}
                        value="all"
                        className="mb-1"
                        control={<Radio sx={{ padding: '2px', marginLeft: '10px' }} size="small" />}
                        label={<TextItem>Semua Produk</TextItem>}
                      />
                      <FormControlLabel
                        disabled={busy}
                        value="2"
                        className="mb-1"
                        control={<Radio sx={{ padding: '2px', marginLeft: '10px' }} size="small" />}
                        label={<TextItem>Produk dengan SKU Produk</TextItem>}
                      />
                      <FormControlLabel
                        disabled={busy}
                        value="1"
                        className="mb-1"
                        control={<Radio sx={{ padding: '2px', marginLeft: '10px' }} size="small" />}
                        label={<TextItem>Tidak ada SKU Produk</TextItem>}
                      />
                      <FormControlLabel
                        disabled={busy}
                        value="3"
                        className="mb-1"
                        control={<Radio sx={{ padding: '2px', marginLeft: '10px' }} size="small" />}
                        label={<TextItem>SKU Duplikat</TextItem>}
                      />
                    </RadioGroup>
                  </FormControl>
                </RadioOption>
                <div className="mt-3">
                  <AsyncButton fullWidth type="submit" color="primary" disabled={busy || isEditingColumnSKU}>
                    Terapkan
                  </AsyncButton>
                </div>
              </form>
            </LeftContentWrap>
          </Grid>
          <Grid item md={9}>
            <div className="d-flex align-items-center justify-content-end">
              {isEditingColumnSKU ? (
                <Button
                  variant="contained"
                  color="primary"
                  startIcon={<SaveSVG />}
                  disabled={busy}
                  onClick={() => {
                    canSkip()
                    setIsEditingColumnSKU(false);
                    // get all changed SKUS
                    const saveAllChangedSKUs = [];
                    changedSKUs.forEach(async (value) => {
                      const payload = {
                        newItemCode: value.newItemCode,
                        itemCode: value.itemCode,
                        skuRecommendations: value.skuRecommendations?.map((item) => ({
                          img_url: item.img_url,
                          selected: item.selected,
                          item_code: item.item_code,
                          item_name: item.item_name,
                          store_name: item.store_name,
                          final_score: item.final_score,
                          channel_name: item.channel_name,
                          variation_values: item.variation_values
                        })) || []
                      };
                      saveAllChangedSKUs.push(saveNewSKUs(payload, detailStore?.store_id));
                    });
                    const saveResults = Promise.all(saveAllChangedSKUs);
                    saveResults
                      .then((res) => {
                        console.log(res);
                        setIsEditingColumnSKU(false);
                        setChangedSKUs(
                          new Map<
                            string,
                            { newItemCode: string; itemCode: string; skuRecommendations: Record<string, unknown>[] }
                          >()
                        );
                        const newQuery: QueryParameters & OtherFilterProps = {
                          ...query.current,
                          type: '2',
                        };
                        setSku('2');
                        showAlert('success', 'Berhasil menyimpan perubahan SKU');
                        setQuery.current(newQuery);
                      })
                      .catch((error) => {
                        setIsEditingColumnSKU(false);
                        setChangedSKUs(
                          new Map<
                            string,
                            { newItemCode: string; itemCode: string; skuRecommendations: Record<string, unknown>[] }
                          >()
                        );
                        console.error('Error saving SKUs:', error);
                        showAlert('error', 'Gagal menyimpan perubahan SKU. Silakan coba lagi.', 5000);
                      });
                  }}
                >
                  Simpan
                </Button>
              ) : (
                <Button
                  variant="contained"
                  color="primary"
                  disabled={busy}
                  startIcon={<EditSVG className="text-white" />}
                  onClick={() => {
                    cantSkip();
                    setIsEditingColumnSKU(true)
                  }}
                >
                  Edit
                </Button>
              )}
            </div>
            <LiteGrid
              busy={busy === false ? undefined : busy}
              flexibleWidth={true}
              columns={columns}
              data={fetcher}
              showRowSelect
              getRefresher={(e) => (refresher.current = e)}
              rowButton={rowButton}
              getQuery={getQuery}
              getSetQuery={getSetQuery}
              onRowAction={handleRowAction}
              isRowLocked={isRowLocked}
              gridName="initial_download_grid"
              customHeight="calc(100vh - 327px)"
              showToolbar={true}
              allowDelete
              // useConfirmDelete={false}
              onDelete={(deletedItem) => {
                handleDelete(deletedItem);
              }}
              havePagination={!isEditingColumnSKU}
              scrollTopOnRrefresh={false}
              isEmpty={
                statusDownload === 'all' && downloadState === 'idle'
                  ? 'Produk yang belum ada disini akan di refresh oleh sistem per 10 detik atau silakan klik refresh untuk meloading data yang sudah terdownload.'
                  : ''
              }
            />
          </Grid>
        </Grid>
      )}
      {/* @TODO: enable after store selected * */}
      <ModalAction
        title="Hapus"
        method="POST"
        urlApi={'product/delete-onboarding-products'}
        btnSubmitColor="secondary"
        mappingRequest={(data) => ({ ids: [data.channel_group_id] })}
        data={deletingItem}
        onClose={onDeleteClose}
        isShow={deleteConfirmation}
      />
      <ModalImportSKU
        data={{ storeId: detailStore?.store_id ?? 0, type: sku, itemName: getValues('q') }}
        open={isShowModalImport}
        onClose={(e, reason, result) => {
          if (!reason && result.success) {
            currentProgress.current = 'importing';
            setProgressState({
              label: progressLabels.importing,
              percentage: 0,
              count: `0 dari ${result.total_rows ?? 0} produk`
            });
            setDownloadState('importing');
            importResult.current = result;
          } else {
            if (result) {
              setProgressState({
                label: progressLabels.importing_failed,
                percentage: 100,
                count: '0 dari 0 produk',
                color: 'error'
              });
              setDownloadState('import_failed')
              currentProgress.current = 'import_failed';
              importResult.current = {
                ...importResult.current,
                failed: result?.errors?.length || 0,
                total_rows: 0,
                errors: result?.errors || []
              };
            }
          }
          setIsShowModalImport(false)
        }} />
    </div>
  );
};

export default withModalIntegration(InitialDownload, true);
